module.exports = __webpack_public_path__ + "static/media/audioControl copy crap.fa0b01ed.bin";